module.exports = __webpack_public_path__ + "img/Show Icon - white.19677901.svg";